// extracted by mini-css-extract-plugin
module.exports = {"container":"BigFiveUserInfo_container__3pSFE","user":"BigFiveUserInfo_user__2AaS2","avatar":"BigFiveUserInfo_avatar__1haZA","button":"BigFiveUserInfo_button__3FI__"};